import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiSolidCheckCircle, BiSolidXCircle } from "react-icons/bi";
import UploadReport from "./uploadReport";
import TestForPackage from "./testsByPackagePopup";
import { FiInfo } from "react-icons/fi";
import { Pagination } from "react-bootstrap";
import DisclaimerPopup from "./disclaimerPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { FaDownload, FaEdit, FaEye, FaRedoAlt } from 'react-icons/fa';
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import jsPDF from "jspdf";
import tmplLogo from "../images/tmplLogo.png";

function EmpAppointments() {
    const { userid } = useParams();
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  const userRole = JSON.parse(localStorage.getItem("data")).role;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 

  const searchData = async () => {
    setLoader(true);
    try {
      const searchUrl = `/api/employeeappointment/userid=${userid}`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setAppointmentDetails(response.data);
      // setFilteredData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    
    try {
      setLoader(true);
      const trans = await axios.get(`/api/employeeappointment/getAllAppointmentsByUserid/userid=${userid}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      const appointments = trans.data.content;
      setAppointmentDetails(appointments);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

const handleViewReport = (reportId) => {
  const url = `/api/employee-appointment-reports/view/${reportId}`;
  // Open in new tab with auth token via a hidden form trick or direct URL
  // Since the endpoint requires Authorization header, we fetch as blob and open
  axios({
    url,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    window.open(blobUrl, "_blank");
  }).catch(() => toast.error("Failed to view report."));
};

const handleDownloadReport = (reportId, fileName) => {
  axios({
    url: `/api/employee-appointment-reports/view/${reportId}`,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName || "report");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  }).catch(() => toast.error("Failed to download report."));
};

const handleBack = () => {
  navigate(-1);
};

const [loading, setLoading] = useState(null);
function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);
  
    const token = JSON.parse(localStorage.getItem("data")).token;
  
    const entitiesToUpdate = ({
      id: id,
      reportstatus: status,
    });
  
    axios
      .post(
        "/api/employeeappointment/approve",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response.data);
        setLoading(null);
        getData();
      })
      .catch((error) => {
       handleError(error);
      });
  }


  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);

  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    getData();
  };

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
      setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };
  const handleRetry = async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/re-trigger-api', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Retried successfully');
    } catch (error) {
      toast.error('Retry failed');
    } finally {
      setLoader(false); 
    }
  };

  const handleFetchReport= async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
     handleError(error);
    } finally {
      setLoader(false); 
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

   const [showImageModal, setShowImageModal] = useState(false);
  
    const handleBookApp = () => setShowImageModal(true);
    const handleCloseModal = () => setShowImageModal(false);
  
 const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const handleCancelAppointment = async (appointment) => {
    setSelectedAppointment(appointment)
    setIsCancelPopupOpen(true);
  };
  
  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/employeeappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
    setLoader(false);
      handleError(error);
 
    }
  };

  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);  
  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

     const handleDownloadReciept = (userid, paymentId) => {
    navigate('/users/payment-receipt', { 
      state: { userid: userid, paymentId:paymentId } 
    });
  };


  return (
    <div>
      
      <div className="d-flex align-items-center justify-content-between mb-2">

      <button className="btn btn-primary" onClick={handleBack}>
      Back
    </button>
  <button className="btn btn-primary" onClick={handleBookApp}>
    Book Appointment
  </button>

    </div>
        <div className="card card-raised">
          <div className="card-body">
            <div className="table-responsive">
             
            <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                <th>Employee Name</th>
                  <th>Date</th>
                  <th>Lab Name</th>
                  <th>Contact Number</th>
                  <th>Package Name</th>
                  <th>Appointment Status</th>
                  <th>Report</th>
                  <th>Reciept</th>
                  <th>Lab Order Status</th>
            
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                 <td
  style={{
    cursor: (
             appointment.appStatus?.appointmentStatus === 'APPOINTMENT CANCELLED' || 
             appointment.appStatus?.appointmentStatus === 'APPOINTMENT COMPLETED') 
            ? "default" 
            : "pointer",
  }}
  title="Upload Report"
  onClick={() => {
    if (
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
    ) {
      handleUploadReport(appointment.id);
    }
  }}
  onMouseOver={(e) => {
    if (
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
      appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
    ) {
      e.target.style.color = "blue";
      e.target.style.textDecoration = "underline";
    }
  }}
  onMouseOut={(e) => {
    e.target.style.color = "";
    e.target.style.textDecoration = "";
  }}
>
  {appointment.emplo?.name} {appointment.emplo?.lastname}
</td>

                      <td>{appointment.date}</td>
                      <td>{appointment.labs?.labname}</td>
                      <td>{appointment.emplo?.phoneno}</td>
            <td>  {appointment.pack!==null && (
                                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                                                 <span style={{
                                                   backgroundColor: '#405469ff',
                                                   color: 'white',
                                                   padding: '6px 12px',
                                                   borderRadius: '20px',
                                                   fontWeight: '500',
                                                   display: 'inline-block',
                                                   fontSize: '14px'
                                                 }}>{appointment.pack?.packagename}</span>
                                                 <FiInfo
                                                    onClick={() => openTestsModal(appointment.packageid)}
                                                   style={{
                                                     cursor: 'pointer',
                                                     fontSize: '24px',
                                                   }}
                                                 />
                                                </div>
            )}
                                   
                         <div>
                            {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                              <>
                          Additional Tests:
                           <ul style={{ margin: 0, paddingLeft: "20px" }}>
                    {
                      appointment.additionalTest.map((test, i) => (
                        <li key={i}>{test.testDetails?.testname}</li>
                      ))
                
                    }
                  </ul>
                  </>
                            )}
                         </div>
                                  </td>
                       <td>
                       <div>{appointment.appStatus?.appointmentStatus}</div>
                       {(appointment.appointmentstatus!=='APPOINTMENT CANCELLED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') && (appointment.appointmentstatus!=='APPOINTMENT COMPLETED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
                       // {appointment.appointmentstatus !== 'CANCELLED' && appointment.appointmentstatus !== 'COMPLETED' && (
                       <>
                         <div>
                           {/* Show the Accept button if the appointment is rescheduled by Lab and not yet confirmed */}
                           {appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CONFIRMED' && 
                             appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' && 
                             appointment.appStatus?.updatedBy !== 'Employee' && (
                             <button
                               className="btn btn-success btn-sm rounded-pill me-2"
                               onClick={() => handleAcceptAppointment(appointment.id)}
                             >
                               Accept
                             </button>
                           )}
                           
                           {/* Cancel button, displayed only if the appointment is neither CANCELLED nor COMPLETED */}
                           <button
                             className="btn btn-danger btn-sm rounded-pill"
                             onClick={() => handleCancelAppointment(appointment)}
                           >
                             Cancel
                           </button>
                         </div>
                         
                         <div className="mt-2">
                           <button
                             className="btn btn-warning btn-sm rounded-pill"
                             onClick={() => handleRescheduleAppointment(appointment.id)}
                           >
                             Reschedule
                           </button>
                         </div>
                       </>
                     )}
                     
                     </td>
                    
                     
  <td>
  {appointment.orderStatus ? (
    appointment.orderStatus?.appointmentReport ? (
        <div>
          <a
            href={appointment.orderStatus.appointmentReport}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Report
          </a>
        </div>
    ) : (
      <button onClick={() => handleFetchReport(appointment)}>Fetch Report</button>
    )
  ) : (
    appointment.reportstatus === 'APPROVED' ? (
      <>
        {/* Show all uploaded report files */}
        {(appointment.reports || []).length > 0 ? (
          <ul className="list-unstyled mb-0">
            {(appointment.reports || []).map((report, ri) => (
              <li key={report.id} className="d-flex align-items-center justify-content-between mb-1" style={{gap:'6px'}}>
                <span
                  style={{cursor:'pointer', color:'#0d6efd', textDecoration:'underline', fontSize:'13px', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}
                  onClick={() => handleViewReport(report.id)}
                  title={report.fileName || `File ${ri + 1}`}
                >
                  {report.fileName || `File ${ri + 1}`}
                </span>
                <FaDownload
                  size={14}
                  style={{cursor:'pointer', color:'#198754', flexShrink:0}}
                  title="Download"
                  onClick={() => handleDownloadReport(report.id, report.fileName)}
                />
              </li>
            ))}
          </ul>
        ) : (
          <span className="text-muted" style={{fontSize:'12px'}}>No files</span>
        )}
        {(userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") && (
          <FaEdit
            className="text-black cursor-pointer mt-1"
            size={16}
            onClick={() => handleUploadReport(appointment.id)}
            title="Modify Report"
            style={{cursor:"pointer"}}
          />
        )}
      </>
    ) : appointment.reportstatus ? (
      "APPROVAL PENDING"
    ) : (
      "No Report Added"
    )
  )}
  <br/>
  <br/>
  <div>{appointment.reportstatus || appointment.orderStatus?.appointmentReport ? (
                          <>
                            {appointment.reportstatus === "REQUESTED" ? (
                              <td id="icon" value={appointment.reportstatus}>
                                &nbsp;
                                {appointment.reportstatus} &nbsp;
                                {loading && (
                                  <div
                                    className="loader"
                                    style={{
                                      position: "relative",
                                      left: "75px",
                                      top: "10px",
                                    }}
                                  ></div>
                                )}{" "}
                                <BiSolidCheckCircle
                                  className="icon"
                                  id="appointment.reportstatus"
                                  style={{ backgroundColor: "green", cursor:"pointer" }}
                                  value="APPROVED"
                                  title="Approve"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "APPROVED")
                                  }
                                />
                                &ensp;
                                <BiSolidXCircle
                                  className="icon"
                                  value="REJECTED"
                                  style={{ backgroundColor: "red", cursor:"pointer" }}
                                  id="appointment.reportstatus"
                                  title="Reject"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "REJECTED")
                                  }
                                />
                              </td>
                            ) : (
                              <td id="icon" value={appointment.reportstatus}>
                                {" "}
                                {appointment.reportstatus}
                              </td>
                            )}
                          </>
                        ) : (
                          null
                        )}</div>
</td>

                          <td 
                            style={{
                              cursor: appointment.paymentId !== null ? "pointer" : "default",
                              textAlign: "center", // Center alignment
                              verticalAlign: "middle", // Vertically align content
                            }} 
                            title={appointment.paymentId !== null ? "Download Receipt" : ""}
                            onClick={() => appointment.paymentId !== null && handleDownloadReciept(appointment.userid, appointment.paymentId)}
                          >
                            {appointment.paymentId !== null ? <FaDownload /> : "NA"}
                          </td>
                              
                      <td>
  <div>{appointment.orderStatus?.status}</div>

  <div>
    {appointment.orderStatus ? (
      <>
      <br/>
        {(appointment.orderStatus?.orderId === "" || appointment.orderStatus?.orderId == null) && (appointment.appointmentstatus!=='APPOINTMENT CANCELLED') ? (  // Check for both empty string and null/undefined
          <>
            <button
              onClick={() => handleRetry(appointment)}
              style={{ cursor: 'pointer', color: 'red' }}
            >
              Retry
              <FaRedoAlt />
            </button>
          </>
        ) : (
          <div>{appointment.orderStatus?.orderId}</div>
        )}
      </>
    ) : (
      <div>NA</div>
    )}
  </div>
</td>

                    </tr>
                  ))
                )}
              </tbody>
            </table>
           
          </div>
          <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
        </div>
        {isUploadModalOpen && (
          <UploadReport
            isOpen={isUploadModalOpen}
            onRequestClose={handleCloseUploadModal}
            empId={selectedAppointmentId}
          />
        )}

{showImageModal && (
           <DisclaimerPopup isOpen={showImageModal} onRequestClose={handleCloseModal} userid={userid}/>
           )}

{isReschedulePopupOpen && (
          <AppointmentReschedule
            isOpen={isReschedulePopupOpen}
            onRequestClose={handleCloseReschedulePopup}
            appointmentId={selectedAppointmentId}
          />
        )}

{isCancelPopupOpen &&(
   <FamilyAppointmentCancel
   isOpen={isCancelPopupOpen}
   onRequestClose={handleCloseCancelPopup}
   appointment={selectedAppointment}
 />
)}

{isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}

        {loader && <div className="loading"></div>}
      </div>
    </div>
 
  );
}

export default EmpAppointments;
